







































































import { Component } from 'vue-property-decorator'
import { getResultList } from '@/request/apis/DataIntegrationRequest'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import Gallery from '@/components/common/Gallery.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import DropdownGroup from '@/components/common/DropdownGroup.vue'

@Component({
  components: {
    DropdownGroup,
    Gallery,
    StickyButton,
    ModuleWrapper,
    ResultWrapper,
    ModuleIntroduction
  },
  beforeRouteUpdate (to, from, next) {
    next()
    // @ts-ignore
    this.getResult()
  }
})
export default class DataIntegrationResult extends RouterHelper {
  private thumbList: any[] = []
  private thumbName: any[] = []
  private imgDownloadUrl: string = ''
  private currentIndex: number = 0
  private qcSummaries: any[] = [] // 质控结果表格
  private resultList: any[] = ['PreProcessing']

  private qcSummaryColumns: string[] = ['Channel', 'total', 'filt', 'kept', 'median_genes_per_cell_before', 'median_genes_per_cell', 'mean_genes_per_cell', 'max_genes_per_cell', 'min_genes_per_cell', 'median_UMI_counts_per_cell_before', 'median_UMI_counts_per_cell', 'mean_UMI_counts_per_cell', 'max_UMI_counts_per_cell', 'min_UMI_counts_per_cell']

  get id () {
    return this.$route.params.id
  }
  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const result = await getResultList(null, this.id).start()
    this.thumbList = result.images
    this.imgDownloadUrl = result.images_download
    this.thumbName = this.thumbList.map((item: string) => {
      return decodeURIComponent(item.split('/')[item.split('/').length - 1].split('.')[0])
    })
    this.qcSummaries = result.qcSummaries
  }

  mounted () {
    this.getResult()
  }
}
